import React from "react"

const SidebarContext = React.createContext<boolean>(false)

export default SidebarContext
